import { ContextualField, PropertyType } from '../../../models';

export const LaunchTask: ContextualField = {
    modelName: 'launchTask',
    propertyType: PropertyType.Boolean,
    label: 'Launch task',
    placeholder: 'Launch task',
    propertyName: 'launchTaskProperty',
    required: false,
    icon: 'fa-clock-o'
};